import { Component } from '@angular/core';
import { MensIntimateWashComponent } from '@components/consultation-request/upsells/mens-intimate-wash/mens-intimate-wash.component';

@Component({
  selector: 'app-mens-intimate-wash-hsv',
  imports: [MensIntimateWashComponent],
  templateUrl: './mens-intimate-wash-hsv.component.html',
})
export class MensIntimateWashHsvComponent {}
